import FieldReadOnly from "../../../../fields3/generic/read-only-value/read-only";
import FieldConfig from "../../../../fields3/proto/field-config";
import {GROUP_INFO} from "../../../../gd/const/fields/field2-groups";
import FieldTaskId_View from "./render/view";
import FieldTaskId_TableCell from "./render/table/table-cell";
import FieldProject_ViewProperty from "../../../generic/entity/project/render/view-property";
import FieldTaskId_ViewProperty from "./render/view-property";

export default class FieldTaskId extends FieldReadOnly {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Task Short Id";
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Task id"

        this.icon               = 'i5-id'

        this.variableName       = '{TASK-ID}'

        this.renderComponents.view          = FieldTaskId_View
        this.renderComponents.viewSmall     = FieldTaskId_View
        this.renderComponents.tableCell     = FieldTaskId_TableCell

        this.renderComponents.viewProperty      = FieldTaskId_ViewProperty
    }

    sortValue(value:any, model?:any) {
        return value ? parseInt(value) : 0
    }
}
